import { Box, Typography } from "@mui/material";
import React, { PropsWithChildren } from "react";
import { Link } from "./Link";
import { Logo } from "./Logo";

type JobDescriptionProps = {
  logo?: string;
  companyName: string;
  jobDetails: string;
  companyUrl: string;
  color: string;
};

export const JobDescription = (
  props: PropsWithChildren<JobDescriptionProps>,
) => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      sx={{
        width: "100%",
        borderRadius: 4,
        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.3)",
      }}
    >
      <Box>
        <Box height="100%" display="flex" position="relative">
          <Box sx={{ position: "absolute", top: 8, right: 8, zIndex: 1 }}>
            {props.logo && <Logo url={props.companyUrl} logo={props.logo} />}
          </Box>
          <Box
            bgcolor="#364137"
            flex={1}
            display="flex"
            overflow="hidden"
            sx={{
              borderTopLeftRadius: 16,
              borderTopRightRadius: 16,
              height: { xs: 200, sm: 280 },
            }}
          >
            {props.children}
          </Box>
        </Box>
      </Box>
      <Box
        flex={1}
        display="flex"
        flexDirection="column"
        gap={6}
        bgcolor="#141313"
        sx={{ borderBottomLeftRadius: 16, borderBottomRightRadius: 16 }}
        p={{ xs: 4, sm: 4, md: 6 }}
        justifyContent="space-between"
      >
        <Box display="flex" gap={{ xs: 1, md: 2 }} flexDirection="column">
          <Typography
            variant="h4"
            sx={{
              textTransform: "uppercase",
              color: "#ffffff",
            }}
          >
            {props.companyName}
          </Typography>
          <Typography
            variant="h6"
            sx={{
              opacity: 0.6,
              fontSize: { xs: "1rem", sm: "1.125rem", md: "1.25rem" },
            }}
          >
            {props.jobDetails}
          </Typography>
        </Box>
        <Link url={props.companyUrl} />
      </Box>
    </Box>
  );
};
